<!-- Modern Profile Card - Morph Design -->
<div class="profile-card" [class.profile-card--expanded]="isExpanded">

    <!-- Loading State -->
    <div class="profile-card__state" *ngIf="loading">
        <div class="profile-card__spinner"></div>
    </div>

    <!-- Error State -->
    <div class="profile-card__state" *ngIf="!loading && error">
        <span class="profile-card__error-icon">⚠️</span>
        <span class="profile-card__error-text">{{ error }}</span>
    </div>

    <!-- Content -->
    <ng-container *ngIf="!loading && !error">

        <!-- ─── Photo Layer (morphs from full-bleed to avatar) ─── -->
        <div class="profile-card__photo-layer">
            <img *ngIf="photoUrl" [src]="photoUrl" alt="" class="profile-card__photo" (error)="photoUrl = null" />
            <div *ngIf="!photoUrl" class="profile-card__photo-placeholder">
                <fa-icon [icon]="['fal', 'user']"></fa-icon>
            </div>
        </div>

        <!-- ─── Compact View (front – visible when collapsed) ─── -->
        <div class="profile-card__compact">
            <!-- Verified Badge -->
            <div class="profile-card__verified" *ngIf="activeTagCount > 0">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
            </div>

            <!-- Expand Button -->
            <button class="profile-card__expand-btn" (click)="toggleExpand()" title="Detaylar">
                <fa-icon [icon]="['fal', 'info-circle']"></fa-icon>
            </button>

            <!-- Gradient Overlay & Content -->
            <div class="profile-card__overlay">
                <h3 class="profile-card__name">
                    <ng-container *ngIf="displayName; else unnamed">{{ displayName }}</ng-container>
                    <ng-template #unnamed>Profil</ng-template>
                </h3>

                <p class="profile-card__description" *ngIf="zoneName">
                    <fa-icon [icon]="['fal', 'map-marker-alt']"></fa-icon>
                    {{ zoneName }}
                </p>
                <p class="profile-card__description" *ngIf="!zoneName && selectedTag?.lastLocationText">
                    <fa-icon [icon]="['fal', 'map-marker-alt']"></fa-icon>
                    {{ selectedTag.lastLocationText }}
                </p>

                <!-- Data Chips -->
                <div class="profile-card__chips">
                    <div class="profile-card__chip" *ngIf="selectedTag?.lastSeenAt">
                        <fa-icon [icon]="['fal', 'clock']"></fa-icon>
                        <span>{{ selectedTag.lastSeenAt | date:'HH:mm' }}</span>
                    </div>
                    <div class="profile-card__chip">
                        <fa-icon [icon]="['fal', 'tag']"></fa-icon>
                        <span>{{ activeTagCount || 0 }} Etiket</span>
                    </div>
                    <div class="profile-card__chip" *ngIf="selectedTag?.history?.length">
                        <fa-icon [icon]="['fal', 'route']"></fa-icon>
                        <span>{{ selectedTag.history.length }} Hareket</span>
                    </div>
                    <div class="profile-card__chip" *ngIf="selectedTag?.properties?.length">
                        <fa-icon [icon]="['fal', 'sliders-h']"></fa-icon>
                        <span>{{ selectedTag.properties.length }} Özellik</span>
                    </div>
                </div>

                <button class="profile-card__action" (click)="openProfile()" [disabled]="!personId">
                    <span>Profili Aç</span>
                    <fa-icon [icon]="['fal', 'arrow-right']"></fa-icon>
                </button>
            </div>
        </div>

        <!-- ─── Expanded View (details – visible when expanded) ─── -->
        <div class="profile-card__details">

            <!-- Header with avatar info + collapse btn -->
            <div class="profile-card__details-header">
                <div class="profile-card__details-identity">
                    <h3 class="profile-card__details-name">
                        {{ displayName || 'Profil' }}
                    </h3>
                    <p class="profile-card__details-location" *ngIf="zoneName || selectedTag?.lastLocationText">
                        <fa-icon [icon]="['fal', 'map-marker-alt']"></fa-icon>
                        {{ zoneName || selectedTag?.lastLocationText }}
                    </p>
                </div>
                <button class="profile-card__collapse-btn" (click)="toggleExpand()">
                    <fa-icon [icon]="['fal', 'times']"></fa-icon>
                </button>
            </div>

            <!-- Tag Selector -->
            <div class="profile-card__tag-switch" *ngIf="tags.length > 1">
                <button *ngFor="let tag of tags" class="profile-card__tag"
                    [class.profile-card__tag--active]="selectedTagId === tag.tagId"
                    (click)="selectTag(tag.tagId); $event.stopPropagation()">
                    {{ tag.label }}
                </button>
            </div>

            <!-- Segmented Tab Bar -->
            <div class="profile-card__tab-bar">
                <button class="profile-card__tab" [class.profile-card__tab--active]="activeBackTab === 'summary'"
                    (click)="activeBackTab = 'summary'">
                    <fa-icon [icon]="['fal', 'id-card']"></fa-icon>
                    <span>Özet</span>
                </button>
                <button class="profile-card__tab" [class.profile-card__tab--active]="activeBackTab === 'history'"
                    (click)="activeBackTab = 'history'">
                    <fa-icon [icon]="['fal', 'route']"></fa-icon>
                    <span>Hareketler</span>
                </button>
                <button class="profile-card__tab" [class.profile-card__tab--active]="activeBackTab === 'properties'"
                    (click)="activeBackTab = 'properties'">
                    <fa-icon [icon]="['fal', 'sliders-h']"></fa-icon>
                    <span>Özellikler</span>
                </button>
            </div>

            <!-- Tab Content -->
            <div class="profile-card__tab-content">

                <!-- ── Özet Tab ── -->
                <div class="profile-card__tab-pane" *ngIf="activeBackTab === 'summary'">
                    <div class="profile-card__quick-stats" *ngIf="selectedTag">
                        <div class="profile-card__stat-card profile-card__stat-card--blue">
                            <fa-icon [icon]="['fal', 'tag']"></fa-icon>
                            <span class="profile-card__stat-card-value">{{ activeTagCount || 0 }}</span>
                            <span class="profile-card__stat-card-label">Etiket</span>
                        </div>
                        <div class="profile-card__stat-card profile-card__stat-card--emerald">
                            <fa-icon [icon]="['fal', 'route']"></fa-icon>
                            <span class="profile-card__stat-card-value">{{ selectedTag.history?.length || 0 }}</span>
                            <span class="profile-card__stat-card-label">Hareket</span>
                        </div>
                        <div class="profile-card__stat-card profile-card__stat-card--violet">
                            <fa-icon [icon]="['fal', 'sliders-h']"></fa-icon>
                            <span class="profile-card__stat-card-value">{{ selectedTag.properties?.length || 0 }}</span>
                            <span class="profile-card__stat-card-label">Özellik</span>
                        </div>
                    </div>

                    <div class="profile-card__info" *ngIf="selectedTag">
                        <div class="profile-card__info-row">
                            <span class="profile-card__info-label">
                                <fa-icon [icon]="['fal', 'clock']"></fa-icon>
                                Son Görülme
                            </span>
                            <span class="profile-card__info-value">
                                {{ selectedTag.lastSeenAt ? (selectedTag.lastSeenAt | date:'short') : '-' }}
                            </span>
                        </div>
                        <div class="profile-card__info-row">
                            <span class="profile-card__info-label">
                                <fa-icon [icon]="['fal', 'map-marker-alt']"></fa-icon>
                                Konum
                            </span>
                            <span class="profile-card__info-value">{{ selectedTag.lastLocationText || '-' }}</span>
                        </div>
                        <div class="profile-card__info-row" *ngIf="selectedTag.tagCode">
                            <span class="profile-card__info-label">
                                <fa-icon [icon]="['fal', 'barcode']"></fa-icon>
                                Tag Kodu
                            </span>
                            <span class="profile-card__info-value">{{ selectedTag.tagCode }}</span>
                        </div>
                    </div>

                    <button class="profile-card__open-profile-btn" (click)="openProfile()" [disabled]="!personId">
                        <fa-icon [icon]="['fal', 'external-link']"></fa-icon>
                        <span>Profili Aç</span>
                    </button>
                </div>

                <!-- ── Hareketler Tab ── -->
                <div class="profile-card__tab-pane" *ngIf="activeBackTab === 'history'">
                    <div *ngIf="selectedTag?.history?.length; else noHistory">
                        <div class="profile-card__history-item" *ngFor="let item of selectedTag.history | slice:0:8">
                            <div class="profile-card__history-dot"></div>
                            <div class="profile-card__history-body">
                                <div class="profile-card__history-location">
                                    {{ item.locationText || '-' }}
                                </div>
                                <div class="profile-card__history-time">
                                    {{ item.firstSeenAt ? (item.firstSeenAt | date:'HH:mm') : '-' }}
                                    <fa-icon [icon]="['fal', 'arrow-right']"
                                        class="profile-card__history-arrow"></fa-icon>
                                    {{ item.lastSeenAt ? (item.lastSeenAt | date:'HH:mm') : '-' }}
                                    <span class="profile-card__history-duration" *ngIf="item.durationText">· {{
                                        item.durationText }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-template #noHistory>
                        <div class="profile-card__empty">
                            <fa-icon [icon]="['fal', 'route']"></fa-icon>
                            <span>Hareket kaydı yok</span>
                        </div>
                    </ng-template>
                </div>

                <!-- ── Özellikler Tab ── -->
                <div class="profile-card__tab-pane" *ngIf="activeBackTab === 'properties'">
                    <div *ngIf="selectedTag?.properties?.length; else noProps">
                        <div class="profile-card__property" *ngFor="let prop of selectedTag.properties">
                            <span class="profile-card__property-name">{{ prop.name }}</span>
                            <span class="profile-card__property-value">{{ prop.value }}</span>
                        </div>
                    </div>
                    <ng-template #noProps>
                        <div class="profile-card__empty">
                            <fa-icon [icon]="['fal', 'sliders-h']"></fa-icon>
                            <span>Özellik tanımlı değil</span>
                        </div>
                    </ng-template>
                </div>

            </div>
        </div>

    </ng-container>
</div>